import React from 'react';

import { find, isArray, isString } from 'lodash';

import ls from 'local-storage';

import baseConstants from '@constants/baseConstants';

import { CURRENCIES } from '@configs/CURRENCIES';

import { getMoment, showDateNoTimeAsDateOnly } from '@libs/NwMoment';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

export const getBaseUrl = () => {
    return baseConstants.baseapiurl;
};

export const checkTenant = (tenantCodes, includeLocal) => {
    const fullurl = window.location.href;
    if ((includeLocal && fullurl.includes('localhost')) || fullurl.includes('dev2')) {
        return true;
    }
    if (tenantCodes === 'local') {
        return fullurl.includes('localhost') || fullurl.includes('dev2');
    }
    if (isArray(tenantCodes)) {
        return tenantCodes.some((tenantCode) => fullurl.includes(tenantCode));
    }
    return fullurl.includes(tenantCodes);
};

export const getRoot = (path) => {
    return '/assets' + path;
};

export const saxonize = (string) => {
    //add 's to the end of a string or only ' if the string ends with s
    if (string.substr(string.length - 1) === 's') {
        return string + "'";
    }
    return string + "'s";
};

export const pluralizeName = (name) => {
    if (!name) return name;
    if (name.endsWith('y')) {
        return name.slice(0, -1) + 'ies';
    }
    if (name.endsWith('s') || name.endsWith('ss') || name.endsWith('x') || name.endsWith('z')) {
        return name + 'es';
    }
    return name + 's';
};

const unbracketize = (stringtounbracketize) => {
    var newstring = stringtounbracketize;
    if (newstring.substr(0, 1) === '{') {
        newstring = newstring.substr(1);
    }
    if (newstring.substr(newstring.length - 1) === '}') {
        newstring = newstring.substr(0, newstring.length - 1);
    }
    return newstring;
};

export const normalizePlaceholder = (placeholder) => {
    if (isString(placeholder)) {
        return unbracketize(placeholder);
    }
    return placeholder;
};

//utils for numbers
export const isEven = (n) => n % 2 === 0;
export const isOdd = (n) => Math.abs(n % 2) === 1;

export const randomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

export const deaccentize = (string) => {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const deaccentizeandlowerize = (string) => {
    return deaccentize(string).toLowerCase();
};

export const getOrdinal = (n) => {
    let ord = 'th';
    if (n % 10 === 1 && n % 100 !== 11) {
        ord = 'st';
    } else if (n % 10 === 2 && n % 100 !== 12) {
        ord = 'nd';
    } else if (n % 10 === 3 && n % 100 !== 13) {
        ord = 'rd';
    }
    return ord;
};

export const friendlyNumber = (num) => {
    const intlFormat = (num) => {
        return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
    };
    if (num >= 1000000) {
        return intlFormat(num / 1000000) + 'M';
    }
    if (num >= 1000) {
        return intlFormat(num / 1000) + 'k';
    }
    return intlFormat(num);
};

//utils for ES6
export function importAll(r) {
    return r.keys().map(r);
}

//utils for Pagination
//Receive the current page, items per page and the whole data array
//returns the sliced data for the current page
export function sliceData(currentPage, itemsPerPage, data) {
    if (!data) {
        return [];
    }
    const offset = (currentPage - 1) * itemsPerPage;
    let cdata = [];
    if (data.length && data.length > itemsPerPage) {
        cdata = data.slice(offset, offset + itemsPerPage);
    } else {
        cdata = data;
    }
    return cdata;
}

export function checkValidPage(currentPage, itemsPerPage, data, callback) {
    if (currentPage !== 1 && data.length > 0) {
        const maxPage = Math.ceil(data.length / itemsPerPage);
        if (currentPage > maxPage && callback) {
            callback(currentPage - 1);
        }
    }
}

export const getCloudFilesContainerUrl = () => {
    const tenantConfigurations = ls.get('nw_tenant_configurations');
    return tenantConfigurations ? tenantConfigurations.CloudFilesContainerUrl : '';
};

//used for contacts and playlist covers (where you can only find guids)
export const getUrlCover = (guid) =>
    getCloudFilesContainerUrl() ? `${getCloudFilesContainerUrl()}/${guid}_c.jpg` : '';

export const getUserCover = (Guid) => getUrlCover(Guid);

export const getVideoCover = (document) => {
    if (document.Thumbnail && document.Thumbnail.Url) {
        return document.Thumbnail.Url;
    }
    //return emptystatesdrawings["emptybook"]
    return null;
};

export const getThumbnailWidth = (media, thumbheight) => {
    let mediaHeight = media.Standard.Height;
    let mediaWidth = media.Standard.Width;
    if (media.Thumbnail && media.Thumbnail.Height) {
        mediaHeight = media.Thumbnail.Height;
    }
    if (media.Thumbnail && media.Thumbnail.Width) {
        mediaWidth = media.Thumbnail.Width;
    }
    if (thumbheight && mediaWidth) {
        const ratio = mediaHeight / thumbheight;
        return mediaWidth / ratio;
    }
    if (!mediaWidth) {
        if (media.type === 'video') {
            return 320;
        }
        return 180;
    }
    return mediaWidth;
};

export const getThumbnailHeight = (p, thumbheight) => {
    if (p.Thumbnail && p.Thumbnail.Height) {
        return p.Thumbnail.Height;
    }
    return thumbheight || 180;
};

export const getBookCover = (book) => {
    if (book.Covers) {
        if (book.Covers.length > 0) {
            const standardcover = find(book.Covers, {
                CoverFormat: 'Standard',
            });
            if (standardcover) {
                return standardcover.Url;
            }
            return book.Covers[0].Url;
        }
    }
    // Non e' un residuo: il backend valorizza CoverUrl con la prima immagine del book,
    // quindi un book con media ma senza cover scelta a mano ha comunque un'anteprima.
    if (book.CoverUrl) {
        return book.CoverUrl;
    }
    //return emptystatesdrawings['emptybook'];
    return null;
};

//UTILS FOR TAGS

export const mapTags = (fulltags, objecttype) => {
    return fulltags.reduce(function (filtered, tag) {
        if (tag.TagTypeName === objecttype) {
            var newTag = { ID: tag.ID, Name: tag.Name.toLowerCase() };
            filtered.push(newTag);
        }
        return filtered;
    }, []);
};

export const sortTags = (tags) => {
    return tags.sort((a, b) =>
        a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : b.Name.toLowerCase() > a.Name.toLowerCase() ? -1 : 0
    );
};

const getItemTags = (item) => item.T || item.Tags || item.PlaylistTags || [];

export const itemHasTag = (item, tag) => {
    if (!item || !tag) {
        return false;
    }
    const tagId = tag.ID;
    const tagName = tag.Name ? tag.Name.toLowerCase() : '';
    return getItemTags(item).some((itemTag) => {
        if (tagId != null && itemTag.ID != null && Number(itemTag.ID) === Number(tagId)) {
            return true;
        }
        if (tagName && itemTag.Name && itemTag.Name.toLowerCase() === tagName) {
            return true;
        }
        return false;
    });
};

// Modalita' del filtro per tag: 'or' basta uno dei tag scelti, 'and' li vuole tutti.
export const TAG_FILTER_MODE_DEFAULT = 'or';

// Filtro per tag di una lista: i valori sono nomi e non ID, perche' arrivano da
// TagFilterPicker. La modalita' arriva dal filtro stesso, quindi due liste diverse
// possono usarne una diversa nello stesso momento.
export const matchesTagFilter = (item, tagFilterNames, mode = TAG_FILTER_MODE_DEFAULT) => {
    if (!tagFilterNames || !tagFilterNames.length) {
        return true;
    }
    if (!item) {
        return false;
    }
    // le liste contatti pre-calcolano i nomi in minuscolo: dove ci sono si evita di rimapparli
    const itemTagNames =
        item._normalizedTagNames ||
        getItemTags(item)
            .filter((itemTag) => itemTag.Name)
            .map((itemTag) => itemTag.Name.toLowerCase());
    const hasTag = (filterName) => itemTagNames.includes(filterName.toLowerCase());
    return mode === 'and' ? tagFilterNames.every(hasTag) : tagFilterNames.some(hasTag);
};

export const countItemsWithTag = (items, tag) => {
    if (!items || !items.length || !tag) {
        return 0;
    }
    return items.filter((item) => itemHasTag(item, tag)).length;
};

// Quanti oggetti cambiano in un'associazione: positivo in add, negativo in remove.
export const tagAssociationDelta = (items, tag, mode) => {
    const already = countItemsWithTag(items, tag);
    const total = items ? items.length : 0;
    if (mode === 'add') {
        return total - already;
    }
    if (mode === 'remove') {
        return -already;
    }
    return 0;
};

export const capitalize = (text) => {
    text = text
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    return text;
};

export const getMediaType = (typeName) => {
    switch (typeName) {
        case 'Files':
            return 1;
        case 'Images':
            return 2;
        case 'Photo':
            return 2;
        case 'Videos':
            return 3;
        default:
            return 1;
    }
};

export const isLandscape = (media) => {
    if ((media.Type && media.Type === 'Video') || (media.TypeName && media.TypeName === 'Video')) {
        return true;
    }
    if (media.Standard && media.Standard.Width && media.Standard.Height) {
        return media.Standard.Width >= media.Standard.Height;
    } else {
        if (media.thumbnailWidth && media.thumbnailHeight) {
            return media.thumbnailWidth >= media.thumbnailHeight;
        }
        if (media.Thumbnail && media.Thumbnail.Width && media.Thumbnail.Height) {
            return media.Thumbnail.Width >= media.Thumbnail.Height;
        }
        return false;
    }
};

export const isVideo = (media) => {
    return media && (media.Type === 'Video' || media.TypeName === 'Video');
};

// VERSIONE CKEDITOR NON USATA
// export const isDocumentPage = () => {
//     const paths = window.location.pathname.split('/');
//     const isDocument = paths.length > 0 && paths[1] === 'document';
//     return isDocument;
// };

export const validateDates = (value) => {
    let error;
    if (value) {
        if (value.startdate.isAfter(value.enddate)) {
            error = 'It ends before it starts';
        }
        if (value.enddate.diff(value.startdate, 'months') > 12) {
            error = 'event longer than a year';
        }
    }
    return error;
};

const getDaysInMonth = (month, year) => {
    return !year || !month ? 31 : new Date(year, month + 1, 0).getDate();
};

export const validateDate = (date, nullable) => {
    let error;
    if (date) {
        if (date.year === null && date.month === undefined && date.day === null) {
            if (nullable) {
                return '';
            }
            return 'Please input date';
        } else if (date.year !== null && date.month !== undefined && date.day !== null) {
            if (getDaysInMonth(date.month, date.year) < date.day) {
                return 'Please input valid date';
            }
            return error;
        } else {
            return 'Please input valid date';
        }
    }
    return error;
};

export const ADDRESS_FIELDS = ['Name', 'Street', 'City', 'Zip', 'County', 'State', 'Country', 'Access'];

const hasAddressFieldValue = (address, field) => Boolean(address[field] && String(address[field]).trim());

// Validator field-level per Formik. Senza campi obbligatori vale la regola di base:
// basta un campo qualsiasi compilato.
// Ritorna una stringa quando l'errore riguarda tutto il blocco, un oggetto campo -> messaggio
// quando riguarda singoli campi obbligatori: CreateNWField distingue i due casi per decidere
// se colorare l'intero riquadro o i soli campi in errore.
export const validateAddressFields =
    (requiredFields = []) =>
    (value) => {
        const address = value || {};

        if (requiredFields.length === 0) {
            const isFilled = ADDRESS_FIELDS.some((field) => hasAddressFieldValue(address, field));
            return isFilled ? undefined : 'At least one address field is required';
        }

        const errors = {};
        for (const field of requiredFields) {
            if (!hasAddressFieldValue(address, field)) {
                errors[field] = `${field} is required`;
            }
        }
        return Object.keys(errors).length > 0 ? errors : undefined;
    };

export const validateVisibility = (visibility, area) => () => {
    if (!visibility.isGlobal) {
        if (!visibility.Areas.find((item) => item === area)) {
            return 'Current area should be included';
        }
    }
    return null;
};

export const getEventFieldName = (eventType) => {
    switch (eventType) {
        case 'travel':
            return 'TravelID';
        case 'followup':
            return 'FollowUpID';
        case 'event':
            return 'EventID';
        case 'meeting':
            return 'MeetingID';
        case 'todo':
            return 'TodoID';
        case 'extjob':
            return 'ExternalJobID';
        case 'accommodation':
            return 'AccommodationID';
        default:
    }
};

export const getCurrency = (currencyCode) => {
    const currency = CURRENCIES.find((item) => item.code === currencyCode);
    return `${currency ? currency.symbol : ''}`;
};

export const validateAmount = (value) => {
    let error;
    if (!value[1]) {
        error = 'Amount is required';
    } else {
        if (isNaN(Number(value[1]))) {
            error = 'Amount is required';
        } else {
            if (Number(value[1]) === 0) {
                error = 'Amount is required';
            }
        }
    }
    return error;
};

export const validateAmountZeroAllowed = (value) => {
    let error;
    if (value[1] === null) {
        error = 'Amount is required';
    } else {
        if (isNaN(Number(value[1]))) {
            error = 'Amount is required';
        }
    }
    return error;
};

export const enumerateDaysBetweenDates = function (startDate, endDate) {
    let dates = [];
    const currDate = getMoment(startDate).startOf('day');
    const lastDate = getMoment(endDate).startOf('day');
    dates.push(currDate.clone().toDate());
    while (currDate.add(1, 'days').diff(lastDate) <= 0) {
        dates.push(currDate.clone().toDate());
    }
    return dates;
};

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : null;
}

function checkBrightness(color) {
    const rgb = hexToRgb(color);
    const brightness = Math.round((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000);
    if (brightness < 150) {
        return '#ffffff';
    } else {
        return '#000000';
    }
}

export const GetForeColor = (backColor) => {
    return checkBrightness(backColor);
};

export const getTransportIcon = (transport) => {
    switch (transport) {
        case 'Plane':
            return byPrefixAndName.fasl['plane-departure'];
        case 'Train':
            return byPrefixAndName.fasl['train'];
        case 'Bus':
            return byPrefixAndName.fasl['bus'];
        case 'Boat':
            return byPrefixAndName.fasl['ship'];
        case 'Driver':
            return byPrefixAndName.fasl['carpool'];
        case 'Car':
            return byPrefixAndName.fasl['car'];
        case 'Taxi':
            return byPrefixAndName.fasl['taxi-alt'];
        default:
            return byPrefixAndName.fasl['plane-departure'];
    }
};

export const getFileTypeIcons = (extension) => {
    switch (extension.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'tif':
        case 'gif':
        case 'png':
            return byPrefixAndName.fasl['file-image'];
        case 'doc':
        case 'docx':
            return byPrefixAndName.fasl['file-word'];
        case 'ppt':
        case 'pptx':
            return byPrefixAndName.fasl['file-word'];
        case 'pdf':
            return byPrefixAndName.fasl['file-pdf'];
        case 'xls':
        case 'xlsx':
        case 'csv':
            return byPrefixAndName.fasl['file-spreadsheet'];
        case 'zip':
        case 'rar':
            return byPrefixAndName.fasl['file-archive'];
        case 'mp4':
        case 'mov':
        case 'mkv':
            return byPrefixAndName.fasl['file-video'];
        case 'txt':
            return byPrefixAndName.fasl['file-lines'];
        default:
            return byPrefixAndName.fasl['file'];
    }
};

export const isImageFile = (extension) => {
    return baseConstants.FileTypes.image.includes(extension.toLowerCase());
};

export const isVideoFile = (extension) => {
    return baseConstants.FileTypes.video.includes(extension.toLowerCase());
};

export const isMediaPreviewableInIframe = (extension) => {
    if (baseConstants.FileTypes.previewableInIframe.includes(extension.toLowerCase())) {
        return true;
    }
    return false;
};

export const isMediaPreviewable = (extension) => {
    if (isImageFile(extension) || isVideoFile(extension) || isMediaPreviewableInIframe(extension)) {
        return true;
    }
    return false;
};

export const validatePeriod = (value, disableDates) => {
    let error;
    if (disableDates && (!value.enableStart || !value.enableEnd)) {
        return null;
    }
    if (value.startDate > value.endDate) {
        error = 'It ends before it starts';
    }
    return error;
};

export const mergeCustomFields = (definitions, values, showEmpty) => {
    const mergedFields = [];
    for (const def of definitions) {
        const value = values[def.Name];
        if (value || showEmpty) {
            mergedFields.push({
                ...def,
                Value: value || null,
            });
        }
    }
    return mergedFields;
};

export const parseCustomFieldValue = (field) => {
    if (field && field.TypeName === 'Date') {
        if (!field.Value) {
            return '';
        }
        return showDateNoTimeAsDateOnly(field.Value);
    }
    if (field && field.TypeName === 'MultipleChoice') {
        if (!field.Value) {
            return '';
        }
        return field.Value.split(',').join(' • ');
    }
    if (field && field.TypeName === 'Boolean') {
        if (field.Value) {
            return <NwIcon icon={byPrefixAndName.fass['check']} />;
        } else {
            return <NwIcon icon={byPrefixAndName.fasl['circle-xmark']} />;
        }
    }
    if (!field.Value) {
        return '';
    }
    return field.Value;
};

export const getCustomFieldValue = (key, value, customFields) => {
    const customField = customFields.find((customField) => customField.Name === key);
    if (customField && customField.TypeName === 'Date') {
        return showDateNoTimeAsDateOnly(value);
    }
    if (customField && customField.TypeName === 'MultipleChoice') {
        return value.split(',').join(' ');
    }
    if (customField && customField.TypeName === 'Boolean') {
        return <NwIcon icon={byPrefixAndName.fass['check']} />;
    }
    return value;
};

export const compareArrayTimes = (time1, time2) => {
    if (time1[0] > time2[0] || (time1[0] === time2[0] && time1[1] > time2[1])) {
        return true;
    }
    return false;
};

export const getEndTime = (previousStartTime, previousEndTime, startTime) => {
    let endTimeValue = previousEndTime[0] * 60 + previousEndTime[1];
    const difference = (endTimeValue === 1439 ? 1440 : endTimeValue) - previousStartTime[0] * 60 - previousStartTime[1];
    let endTime = startTime[0] * 60 + startTime[1] + difference;
    endTime = endTime >= 1440 ? 1439 : endTime;
    return endTime;
};

export const checkIfArrayIsUnique = (array) => {
    let map = {},
        i,
        size;

    for (i = 0, size = array.length; i < size; i++) {
        if (map[array[i]]) {
            return false;
        }

        map[array[i]] = true;
    }

    return true;
};

const isSameGroup = (group1, group2) => {
    if (!group1 && !group2) {
        return true;
    }
    return group1 === group2;
};

export const groupPackage = (currentPackage) => {
    if (currentPackage) {
        let groupedModels = [];
        let modelIdsByGroup = [];
        const groupNames = [
            ...new Set(
                currentPackage.Models.map((item) => (item.Group ? item.Group : '')).filter(
                    (value) => value !== null && value !== ''
                )
            ),
        ];
        if (groupNames.length === 1 && !groupNames[0]) {
            //groupedModels = { models: [...currentPackage.Models] }
            //TODO: modificare con oggetto più complesso
            groupedModels = [
                {
                    groupName: '',
                    groupLabel: 'models',
                    models: [...currentPackage.Models],
                },
            ];
            modelIdsByGroup.push({
                group: '',
                modelIDs: currentPackage.Models.map((item) => item.ID),
            });
        } else {
            //TODO: modificare con ciclo manuale per costruzione oggetto
            // const groupBy = key => array =>
            //     array.reduce((objectsByKeyValue, obj) => {
            //         const value = obj[key] ? obj[key] : 'not grouped';
            //         objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            //         return objectsByKeyValue;
            //     }, {});
            //const groupByGroupName = groupBy('Group');
            //groupedModels = groupByGroupName(currentPackage.Models)
            for (const mod of currentPackage.Models) {
                //find group in groupmodels
                const groupIndex = groupedModels.findIndex((group) => isSameGroup(group.groupName, mod.Group));
                if (groupIndex !== -1) {
                    groupedModels[groupIndex].models.push(mod);
                } else {
                    groupedModels.push({
                        groupName: mod.Group,
                        groupLabel: mod.Group ? mod.Group : groupNames.length > 0 ? 'ungrouped' : 'models (no groups)',
                        models: [mod],
                    });
                }
                //find group in modelIdsByGroup
                const modelIdsByGroupIndex = modelIdsByGroup.findIndex((group) => isSameGroup(group.group, mod.Group));
                if (modelIdsByGroupIndex !== -1) {
                    modelIdsByGroup[modelIdsByGroupIndex].modelIDs.push(mod.ID);
                } else {
                    modelIdsByGroup.push({
                        group: mod.Group,
                        modelIDs: [mod.ID],
                    });
                }
            }
        }
        return {
            ...currentPackage,
            GroupedModels: groupedModels,
            GroupNames: groupNames,
            ModelIdsByGroup: modelIdsByGroup,
        };
    }
};

export const getHighlightedText = (text, highlight) => {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === highlight.toLowerCase() ? <b key={index}>{part}</b> : part
            )}
        </span>
    );
};

export const getValidText = (text) => {
    return text ? text : '';
};

export const isEmpty = (value) => {
    return (
        value === undefined ||
        value === null ||
        (typeof value === 'object' && Object.keys(value).length === 0) ||
        (typeof value === 'string' && value.trim().length === 0)
    );
};

export const findPath = (websites, websiteCode, sectionCode, prefix, hideWebsiteName = false) => {
    let path = '';
    const findSubPath = (data, sectionCode, subPath) => {
        for (const item of data) {
            if (item.code.toLowerCase() === sectionCode.toLowerCase()) {
                return `${subPath.toUpperCase()} > ${item.name.toUpperCase()}`;
            }
            if (item.subNav && item.subNav.length) {
                const _path = findSubPath(
                    item.subNav,
                    sectionCode,
                    `${subPath.toUpperCase()} > ${item.name.toUpperCase()}`
                );
                if (_path) return _path;
            }
        }
        return '';
    };
    for (const website of websites) {
        if (website.Code.toLowerCase() === websiteCode.toLowerCase()) {
            const _subPath = findSubPath(website.Structure.nav, sectionCode, '');
            if (!hideWebsiteName) {
                path = `${prefix}${website.Name.toUpperCase()} - ${_subPath.slice(2)}`;
            } else {
                path = `${prefix}${_subPath.slice(2)}`;
            }
            break;
        }
    }
    //path must be trimmed
    return path.trim();
};

export const isAddressEmpty = (address) => {
    return (
        (!address.Street || address.Street === null || address.Street === '' || address.Street === ' ') &&
        (!address.City || address.City === null || address.City === '' || address.City === ' ') &&
        (!address.Country || address.Country === null || address.Country === '' || address.Country === ' ')
    );
};

export const getEmptyAddress = () => {
    return {
        Street: '',
        City: '',
        Zip: '',
        State: '',
        County: '',
        Country: '',
        Access: '',
    };
};
